export const salesContracts = true;
export const invoices = true;
export const commercialInvoices = true;
export const packingLists = true;
export const shippingAdvises = true;
export const packingOrders = false;
export const productReleaseOrders = false;
export const fumigationCertificates = false;
export const healthCertificates = false;
export const weightAndQualityCertificates = false;
export const portDispatches = false;
export const technicalAndFinancialOffers = false;